var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('link-document-markdown',{staticClass:"link-document-item-text",attrs:{"value":_vm.data.text}})}
var staticRenderFns = []

export { render, staticRenderFns }